import { render, staticRenderFns } from "./DowngradeInfo.vue?vue&type=template&id=1d47976d&"
import script from "./DowngradeInfo.vue?vue&type=script&lang=js&"
export * from "./DowngradeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports